import { Action } from "api/action_types/autocomplete";
import { ActionType } from "api/action_types/autocomplete";

interface State {
  predictions: any[]
}

const initialState = {
  predictions: []
}

export const autocompleteReducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case ActionType.GET_AUTOCOMPLETE_RESULTS:
      return {
        ...state,
        predictions: action.predictions
      }
    default:
      return state;
  }
}



